import Flatten from '../../../node_modules/@flatten-js/core/dist/main.mjs'; 
const {point, Polygon, Segment} = Flatten;


export function baseSpiral(position, radius, nbPointsInLayer, nozzle_diameter, zOffset=0, rotation=0){ 
    // Add nested archemedes spirals centered at the middle of the vessel, width of spiral based on nozzle_diameter
    let basePath = [];
    let height = position[2] + zOffset;

    let diameter = radius*2;
    let layers = (nbPointsInLayer*diameter/(nozzle_diameter*4));
    let scale = nozzle_diameter/Math.PI;
    let bias = .0001;
    let step = 2 * Math.PI / nbPointsInLayer;

    let angularOffset = ((radius % nozzle_diameter) * Math.PI) / nozzle_diameter; //start spiral at x=0, y=radius
    if(radius % (nozzle_diameter * 2) < nozzle_diameter){ //ensure spiral does not start at x=0, y=-radius
        angularOffset += Math.PI;
    }

    let outwardOffset = nbPointsInLayer % 2 == 0 ? Math.PI/2 : Math.PI/2 + Math.PI/(nbPointsInLayer); //offset outward spiral rotation to align with inward spiral
    for (let angle = -layers * step; angle < layers * step; angle += step) {
        let spiralRadius = scale * (angle);
        //inward spiral
        if(angle < 0){
            const newPoint = {
                x: (bias + position[0] + spiralRadius * Math.cos(angle + angularOffset + rotation)),
                y: (bias + position[1] + spiralRadius * Math.sin(angle + angularOffset + rotation)),
                z: height,
                t: 0
            }
            basePath.push(newPoint);
        }
        else {
            //outward spiral
            let radialOffset = ((radius - (nozzle_diameter/2)) % (nozzle_diameter));
            if (radialOffset < nozzle_diameter/2 ) { //offset outward spiral radially so that it does not overlap with inward spiral
                radialOffset += nozzle_diameter;
            };
            const newPoint = { 
                x: (bias + position[0] + (spiralRadius + radialOffset) * Math.sin(angle + angularOffset + outwardOffset - rotation)),
                y: (bias + position[1] + (spiralRadius + radialOffset) * Math.cos(angle + angularOffset + outwardOffset - rotation)),
                z: height,
                t: 0
            }
            basePath.push(newPoint);
        }
    }
    //swap order of inward and outward spirals so that spiral will always end at x=0, y=radius
    return basePath.reverse();
}

function offsetPoint(pivot, point, rotation){
    let rotationRad = rotation * Math.PI/180;
    point[0] -= pivot[0];
    point[1] -= pivot[1];

    let pX = point[0] * Math.cos(rotationRad) - point[1] * Math.sin(rotationRad);
    let pY = point[0] * Math.sin(rotationRad) + point[1] * Math.cos(rotationRad);
    return [pX + pivot[0], pY + pivot[1]];
}

 export function baseFill(position, radius, nbPointsInLayer, nozzle_diameter, path, zOffset=0, rotation=0){
    // Add lines filling in the base of the vessel
    let basePath = [];
    let height = position[2] + zOffset;
    for(let i = 0; i < nbPointsInLayer; i++){
        basePath.push(point(path[i].x, path[i].y));
    }

    let baseCircle = new Polygon(basePath);
    let diameter = radius*2;
    let start = [position[0] - diameter, position[1] - diameter, zOffset];
    let newPoints = [];

    for (let i = 0; i < (diameter*2); i+=nozzle_diameter){
        let p1 = offsetPoint(position, [start[0]+(i), start[1]], rotation);
        let p2 = offsetPoint(position, [start[0]+(i), start[1]+(diameter*2)], rotation);
        let line = new Segment(point(p1), point(p2));
        let intersectionPoints = (line.intersect(baseCircle).map(pt => [pt.x, pt.y])).flat();
        if(intersectionPoints.length == 4){
            const newPointBottom = {
                x: intersectionPoints[0],
                y: intersectionPoints[1],
                z: height,
                t: 0
            }
            const newPointTop = {
                x: intersectionPoints[2],
                y: intersectionPoints[3],
                z: height,
                t: 0
            }
            if(i % (2*nozzle_diameter) == 0){
                newPoints.push(newPointBottom, newPointTop);
            } else{
                newPoints.push(newPointTop, newPointBottom);
            }
        } 
    }
    return newPoints;
}

export function base(position, radius, layerHeight, nbPointsInLayer, nozzle_diameter, path){
    let fill = baseFill([position[0], position[1], position[2] - (layerHeight * 2)], radius, nbPointsInLayer, nozzle_diameter, path, 0, 0);
    let spiral = baseSpiral([position[0], position[1], position[2] - layerHeight], radius, nbPointsInLayer, nozzle_diameter, 0, 0);
    return fill.concat(spiral);
}

export function addBase(b, path){
    return b.concat(path);
}

window.baseSpiral = baseSpiral;
window.baseFill = baseFill;
window.addBase = addBase;
window.base = base;